/**
 * CRM Integration Constants
 */

// CRM Integration Types - Frozen object
export const CRM_TYPES = Object.freeze({
  DEALERSOCKET: "DS",
  SALESFORCE: "SF",
  VIN_SOLUTIONS: "VIN",
  DEALER_TEAM: "DT",
  ADF: "ADF",
  EL: "EL",
  MOMENTUM: "MF",
  TEKION: "TK",
});

// CRM Type Display Names
export const CRM_TYPE_LABELS = Object.freeze({
  [CRM_TYPES.DEALERSOCKET]: "Dealersocket",
  [CRM_TYPES.SALESFORCE]: "Salesforce",
  [CRM_TYPES.VIN_SOLUTIONS]: "Vin Solutions",
  [CRM_TYPES.DEALER_TEAM]: "Dealer Team",
  [CRM_TYPES.ADF]: "ADF",
  [CRM_TYPES.EL]: "Elead",
  [CRM_TYPES.MOMENTUM]: "Momentum",
  [CRM_TYPES.TEKION]: "Tekion",
});

// CRM Types that use Salesforce-like API structure
export const SALESFORCE_LIKE_TYPES = Object.freeze([CRM_TYPES.SALESFORCE, CRM_TYPES.DEALER_TEAM]);

// CRM Types that require Dealer ID
export const DEALER_ID_REQUIRED_TYPES = Object.freeze([
  CRM_TYPES.DEALERSOCKET,
  CRM_TYPES.VIN_SOLUTIONS,
]);

// CRM Field Names
export const CRM_FIELD_NAMES = Object.freeze({
  API_URL: "sfApiUrl",
  API_KEY: "sfApiKey",
  API_USER: "sfApiUser",
  CERTIFICATE_KEY: "sfCertificateKey",
  DEALER_ID: "crmDealerId",
  FRANCHISE_ID: "crmFranchiseId",
  LEAD_SOURCE_ID: "vsLeadSourceId",
  ADF_EMAIL: "adfEmail",
});

// Helper functions
export const getCrmTypeLabel = crmType => {
  return CRM_TYPE_LABELS[crmType] || crmType;
};

export const isSalesforceType = crmType => {
  return SALESFORCE_LIKE_TYPES.includes(crmType);
};

export const requiresDealerId = crmType => {
  return DEALER_ID_REQUIRED_TYPES.includes(crmType);
};
